module.exports = __webpack_public_path__ + "static/radikal_light-webfont-6e7ab24a6901d1c04f30c3a201d5b208.woff";